export default __webpack_public_path__ + "static/media/Card-Texture.83368703.png";